<template>
  <div class="cookie-modal" v-if="!showCookieModal">
    <div class="cookie-content">
      <span v-if="manageIsVisible">
        <div class="chekbox-container">
          <label class="chekbox-label">
            <div class="chekbox-label-wrapper">
              <input type="checkbox" disabled v-model="essential" />
              <div class="checkbox"></div>
              <div class="title small">Advertising</div>
              <div class="desc">
                Advertising cookies are used to make advertising messages more
                relevant to you.
              </div>
            </div>
          </label>
        </div>
        <div class="chekbox-container">
          <label class="chekbox-label">
            <div class="chekbox-label-wrapper">
              <input type="checkbox" v-model="optional" />
              <div class="checkbox"></div>
              <div class="title small">Customization Cookies</div>
              <div class="desc">
                We use these cookies to gather information on how our website is
                being used so we can continuously improve it.
              </div>
            </div>
          </label>
        </div>
        <div class="chekbox-container">
          <label class="chekbox-label">
            <div class="chekbox-label-wrapper">
              <input type="checkbox" v-model="google" />
              <div class="checkbox"></div>
              <div class="title small">Functionality Cookies</div>
              <div class="desc">
                These cookies improve the performance and functionality of our
                website but are not essential for its use.
              </div>
            </div>
          </label>
        </div>

        <div class="buttons">
          <button class="button colored" @click="acceptCookies">
            <span>Accept all</span>
          </button>
          <button @click="acceptCookies" class="button colored">
            <span>Accept selected</span>
          </button>
          <button @click="declineCookies" class="button colored manage-button">
            <span>Decline</span>
          </button>
        </div>
      </span>
      <span v-else>
        <div class="title small">{{ $t("Warm Cookie Welcome from us!") }}</div>

        <p class="desc" v-if="textPageList && textPageList.length">
          {{ $t("cookie_desc") }}
          <a @click="$parent.goToPage('cookie')" class="desc link">{{
            textPageList.filter((item) =>
              item.title.toLowerCase().includes("cookie")
            )[0].title
          }}</a>
          {{ $t("for the full scoop.") }}
        </p>
        <div class="buttons">
          <button class="button colored" @click="acceptCookies">
            <span>{{ $t("Agree") }}</span>
          </button>
          <button class="button colored" @click="showCookieModal = false">
            <span>{{ $t("Decline") }}</span>
          </button>
          <button @click="manageCookies" class="button manage-button colored">
            <span>{{ $t("Manage Preferences") }}</span>
          </button>
        </div>
      </span>
    </div>
  </div>
</template>

<script>
import VueCookies from "vue-js-cookie";

export default {
  name: "CookieModal",
  props: {
    textPageList: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      showCookieModal: VueCookies.get("cookiesAccepted"), // Check if user accepted cookies
      manageIsVisible: false,
      essential: true,
      google: false,
      optional: false,
    };
  },
  methods: {
    acceptCookies() {
      this.showCookieModal = true;
      VueCookies.set("cookiesAccepted", "true", 365); // Set a cookie that lasts for a year
    },
    declineCookies() {
      this.showCookieModal = true;
      VueCookies.set("cookiesAccepted", "false", 365);
    },
    manageCookies() {
      this.manageIsVisible = true;
    },
  },
};
</script>
<style scoped>
.cookie-modal {
  position: fixed;
  bottom: 10px;
  left: 10px;
  width: 100%;
  background-color: #1d1d24;
  box-shadow: 0px 8px 20px rgba(84, 78, 99, 0.07);
  text-align: center;
  max-width: 550px;
  margin: 40px 0 0 auto;
  border-radius: 8px;
  padding: 20px;
  z-index: 3;
}
.cookie-modal .desc {
  font-size: 14px;
  line-height: 18px;
}
.cookie-modal .button {
  display: inline-block;
  color: #ffffff;
  padding: 3px 8px;
}
.cookie-content {
  font-size: 14px;
  margin-bottom: 10px;
}
.buttons {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
}
.cookie-content .chekbox-label .title.small {
  font-size: 18px;
  line-height: 24px;
}
.cookie-content .chekbox-container + .chekbox-container {
  margin-top: 16px;
}
.accept-button {
  background-color: #007bff;
  color: #fff;
  border: none;
  padding: 10px 20px;
  border-radius: 5px;
  cursor: pointer;
}

.accept-button:hover {
  background-color: #0056b3;
}

.chekbox-label-wrapper {
  position: relative;
  padding-left: 40px;
  text-align: left;
}
.chekbox-label-wrapper::before {
  content: "";
  width: 22px;
  height: 22px;
  border-radius: 4px;
  background: #21242a;
  border: 1px solid #414956;
  position: absolute;
  left: 0;
  top: 0;
  cursor: pointer;
}
.checkbox {
  content: "";
  width: 16px;
  height: 16px;
  position: absolute;
  border-radius: 2px;
  left: 4px;
  top: 4px;
  background: #ed59e3;
  opacity: 0;
  visibility: hidden;
  transition: 0.3s;
}
input:checked + .checkbox {
  opacity: 1;
  visibility: visible;
}
.chekbox-label .desc {
  position: static;
  color: #fff;
  font-size: 14px;
  font-weight: 400;
  line-height: 21px;
  padding: 0;
}
.chekbox-label a.desc {
  color: #1463d9;
  text-decoration: underline;
}
.chekbox-container {
  flex: 1;
  text-align: left;
}
.chekbox-label .title {
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
}
.chekbox-label a.title {
  color: #297ae5;
}
.chekbox-label input {
  display: none;
}
</style>
